module.exports = __webpack_public_path__ + "static/step_2_1-b0247668f5b4cc1a7c137592eea0d567.svg";